import Body from "./Body";
import SettingStore from "../../../store/Setting/Setting.store";
import { ReactComponent as ActAdminIcon } from "../../../assets/Icons/Setting/Permission/VerticalAccess/ActAdmin.svg";
import { ReactComponent as ActSubAdminIcon } from "../../../assets/Icons/Setting/Permission/VerticalAccess/ActSubAdmin.svg";
import { useEffect, useState } from "react";
import signImage from "../../../assets/Images/TestImg/Signature.png";
import ActCoAdmin from "../../../components/PagesComponents/Setting/Permission/Co-Admin/ActCoAdmin.component";
import ActCoSubAdmin from "../../../components/PagesComponents/Setting/Permission/Co-Admin/ActCoSubAdmin.component";
import ActAdminVertical from "../../../components/PagesComponents/Setting/Permission/VerticalAccess/ActAdminVertical.component";
import ActSubAdminVertical from "../../../components/PagesComponents/Setting/Permission/VerticalAccess/ActSubAdminVertical.component";

const Permission = () => {
  const { currentTab, setCurrentTab } = SettingStore(); //admininfo,basicinfo,advanceinfo,documentinfo
  // eslint-disable-next-line no-unused-vars
  const [adminInfo, setAdminInfo] = useState({
    gender: "Male",
    profileImage: "https://randomuser.me/api/portraits/men/75.jpg", // or use actual source
    id: "30223893452",
    signature: signImage, // replace with actual signature image
    name: "Kalim Hossain",
    email: "abc@gmail.com",
    joiningDate: "2 November, 2024",
    workingField: "Management",
    reportingTo: "Supreme",
    experience: "1-2 Years",
    address: "Gobindapur, Birsingah, North 24 Parganas",
    phone: "9876543210",
    designation: "President",
    relationship: "Unmarried",
    salary: "30000",
    bloodGroup: "B+",
    experienceField: "Social work",
    aadhaarNumber: "123456789012",
    aadhaarVerified: true,
    positionColor: "#F498C6", // default or chosen color
  });

  const handelCurrentTab = () => {
    //logic for tab switching admininfo,basicinfo,advanceinfo,documentinfo
    if (currentTab === "coActAdmin") {
      return <ActCoAdmin data={adminInfo} setCurrentTab={setCurrentTab} />;
    } else if (currentTab === "coSubAdmin") {
      return <ActCoSubAdmin data={""} setCurrentTab={setCurrentTab} />;
    } else if (currentTab === "actAdmin") {
      return <ActAdminVertical data={""} setCurrentTab={setCurrentTab} />;
    } else if (currentTab === "actSubAdmin") {
      return <ActSubAdminVertical data={""} setCurrentTab={setCurrentTab} />;
    } else {
      return "invalid Path";
    }
  };

  const intituteIcons = {
    "For act admin": (
      <ActAdminIcon
        className={
          currentTab === "actAdmin" ? "activeSettingPathChangerBtnIcon" : ""
        }
      />
    ),
    "For sub admin": (
      <ActSubAdminIcon
        className={
          currentTab === "actSubAdmin" ? "activeSettingPathChangerBtnIcon" : ""
        }
      />
    ),
  };

  const institutePathName = {
    "For act admin": "actAdmin",
    "For sub admin": "actSubAdmin",
  };
  const [institutePaths, setIntitutePaths] = useState([
    "For act admin",
    "For sub admin",
  ]);
  useEffect(() => {
    setCurrentTab("coActAdmin");
  }, [setCurrentTab]);
  const _this = {
    currentTab,
    setCurrentTab,
    handelCurrentTab,
    intituteIcons,
    institutePathName,
    institutePaths,
    setIntitutePaths,
  };
  return <Body {..._this} />;
};

export default Permission;
